var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "unitary_form",
      attrs: { onSubmit: "return false;" },
      on: { submit: _vm.test }
    },
    [
      _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card-text",
                { staticClass: "background darken-1" },
                [
                  _c(
                    "div",
                    { staticClass: "ml-1 background--text text--lighten-5" },
                    [_vm._v("\n\t\t\t\t\tRéférence suifa\n\t\t\t\t")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-text-field",
                    {
                      staticClass: "grv-input",
                      attrs: {
                        solo: "",
                        rules: [_vm.checkRequired, _vm.checkRefSuifa],
                        name: "Référence suifa",
                        loading: _vm.suifaInfos.loading
                      },
                      on: {
                        change: function($event) {
                          return _vm.getBehiveAssetInfo(
                            _vm.form.parameters.suifa_ref
                          )
                        }
                      },
                      model: {
                        value: _vm.form.parameters.suifa_ref,
                        callback: function($$v) {
                          _vm.$set(_vm.form.parameters, "suifa_ref", $$v)
                        },
                        expression: "form.parameters.suifa_ref"
                      }
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { slot: "append", bottom: "" },
                          slot: "append"
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                icon: "",
                                small: "",
                                disabled: !_vm.form.parameters.suifa_ref,
                                loading: _vm.suifaInfos.loading
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getBehiveAssetInfo(
                                    _vm.form.parameters.suifa_ref
                                  )
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("search")])],
                            1
                          ),
                          _vm._v(
                            "\n\t\t\t\t\t\tGet data from Behive/Suifa\n\t\t\t\t\t"
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errors
                    ? _c(
                        "div",
                        _vm._l(_vm.errors, function(error) {
                          return _c(
                            "p",
                            { key: error.id, staticClass: "error--text" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(error) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.suifaInfos.data && _vm.suifaInfos.data.t_aux_proprio
                    ? _c("table", { staticClass: "mt-2 infos-table" }, [
                        _c(
                          "tbody",
                          [
                            _vm.suifaInfos.data.t_aux_proprio.t_libelle ||
                            _vm.suifaInfos.data.t_aux_proprio.t_auxiliaire
                              ? _c("tr", [
                                  _c("th", [_vm._v("Ayant droit")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.suifaInfos.data.t_aux_proprio
                                            .t_libelle
                                        ) +
                                        " - (" +
                                        _vm._s(
                                          _vm.suifaInfos.data.t_aux_proprio
                                            .t_auxiliaire
                                        ) +
                                        ")\n\t\t\t\t\t\t\t"
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [_vm._v("Asset")]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _vm.suifaInfos.data.type_sup.code_type_sup
                                    ? _c(
                                        "v-chip",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            small: "",
                                            label: "",
                                            color: "background lighten-1"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.suifaInfos.data.type_sup
                                                  .code_type_sup
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.suifaInfos.data.titre.titre_princ
                                    ? _c("span", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.suifaInfos.data.titre
                                                .titre_princ
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm.suifaInfos.data.asset_size &&
                                    String(_vm.suifaInfos.data.asset_size)
                                      .length < 10
                                      ? _c("span", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t- " +
                                              _vm._s(
                                                _vm.$weight.bitRoundToTwo(
                                                  _vm.suifaInfos.data
                                                    .asset_size,
                                                  2
                                                )
                                              ) +
                                              " Mo\n\t\t\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      : _vm.suifaInfos.data.asset_size
                                      ? _c("span", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$weight.bitRoundToTwo(
                                                  _vm.suifaInfos.data
                                                    .asset_size,
                                                  3
                                                )
                                              ) +
                                              " Go\n\t\t\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.suifaInfos.data.type_sup.code_type_sup
                              ? _c("tr", [
                                  _c("th", [_vm._v("Contrat")]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.localHasContract
                                        ? _c(
                                            "v-icon",
                                            {
                                              attrs: { color: "green accent-3" }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\ttask_alt\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "v-icon",
                                            { attrs: { color: "red" } },
                                            [_vm._v("block")]
                                          )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.suifaInfos.data &&
                            _vm.suifaInfos.data.cpls &&
                            _vm.suifaInfos.data.cpls.length > 0
                              ? _c("tr", [
                                  _c("th", [_vm._v("Liste des DCP")]),
                                  _vm._v(" "),
                                  _c("td")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.suifaInfos.data.cpls, function(cpls) {
                              return _c("tr", { key: cpls.id }, [
                                _c(
                                  "td",
                                  {
                                    staticClass: "pl-3",
                                    attrs: { colspan: "2" }
                                  },
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass: "mx-0 w-45",
                                        attrs: {
                                          label: "",
                                          small: "",
                                          color: "background lighten-1"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(cpls.folder_type) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(cpls.folder_name) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    ),
                                    cpls.folder_size > 0
                                      ? _c("span", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                          String(cpls.folder_size).length < 10
                                            ? _c("span", [
                                                _c("strong", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$weight.bitRoundToTwo(
                                                          cpls.folder_size,
                                                          2
                                                        )
                                                      ) +
                                                      " Mo\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ])
                                            : _c("span", [
                                                _c("strong", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$weight.bitRoundToTwo(
                                                          cpls.folder_size,
                                                          3
                                                        )
                                                      ) +
                                                      " Go\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ])
                                        ])
                                      : cpls.folder_taille > 0
                                      ? _c("span", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                          String(cpls.folder_taille).length < 10
                                            ? _c("span", [
                                                _c("strong", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$weight.bitRoundToTwo(
                                                          cpls.folder_taille,
                                                          2
                                                        )
                                                      ) +
                                                      " Mo\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ])
                                            : _c("span", [
                                                _c("strong", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$weight.bitRoundToTwo(
                                                          cpls.folder_taille,
                                                          3
                                                        )
                                                      ) +
                                                      " Go\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ])
                                              ])
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.errors.length && this.suifaInfos.data
                    ? _c(
                        "v-layout",
                        {
                          staticClass: "pa-2 mt-4",
                          attrs: { row: "", wrap: "", "align-end": "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "ml-2 background--text text--lighten-5"
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\tType de stockage\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-select", {
                                staticClass: "grv-input",
                                attrs: {
                                  solo: "",
                                  dense: "",
                                  flat: "",
                                  name: "Type de stockage",
                                  "menu-props": { contentClass: "grv-menu" },
                                  "prepend-inner-icon": "archive",
                                  rules: [_vm.checkRequired],
                                  items: _vm.storage_list
                                },
                                model: {
                                  value: _vm.form.parameters.server_storage,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.parameters,
                                      "server_storage",
                                      $$v
                                    )
                                  },
                                  expression: "form.parameters.server_storage"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c("v-checkbox", {
                                staticClass: "mb-2 pl-2 grv-input",
                                attrs: {
                                  "hide-details": "",
                                  label: "Supprimer la source",
                                  name: "Supprimer la source",
                                  color: "primary"
                                },
                                model: {
                                  value: _vm.form.parameters.remove_source,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.parameters,
                                      "remove_source",
                                      $$v
                                    )
                                  },
                                  expression: "form.parameters.remove_source"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bac0aac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bac0aac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/forms/launcher_form_dcp.vue
// module id = null
// module chunks = 